import { Tooltip } from '@mui/material';
import cn from 'classnames';
import * as React from 'react';

import { ReactComponent as CustomizableIcon } from '../../../assets/images/icon-customizible.svg';
import { CUSTOMIZABLE_ITEM_INDICATOR_HINT_TEXT } from '../../../constants/inventories';

import styles from './CustomizableItemIndicator.module.scss';

export interface ICustomizableItemIndicatorProps {
  className?: string;
  title?: string;
}

const CustomizableItemIndicator: React.FC<ICustomizableItemIndicatorProps> = ({
  className,
  title = CUSTOMIZABLE_ITEM_INDICATOR_HINT_TEXT,
}) => {
  return (
    <Tooltip title={title} arrow placement="top">
      <div>
        <CustomizableIcon className={cn(styles.icon, className)} />
      </div>
    </Tooltip>
  );
};

export default CustomizableItemIndicator;
